export default __webpack_public_path__ + "static/media/favicon-admin.07bfe16c.png";